module.exports = __webpack_public_path__ + "img/404.ee15e94a.svg";